import React from "react";
import { PiSealCheckFill } from "react-icons/pi";
import { FiBriefcase } from "react-icons/fi";
import { BsCashStack } from "react-icons/bs";
import { FaBriefcase } from "react-icons/fa";
import useIntersectionObserver from "./home-animation";
export default function HomeJobListing({ jobList }) {
  const [sectionRef1, isVisible1] = useIntersectionObserver({ threshold: 0.1 });
  const [sectionRef2, isVisible2] = useIntersectionObserver({ threshold: 0.1 });
  const [sectionRef3, isVisible3] = useIntersectionObserver({ threshold: 0.1 });
  const [sectionRef4, isVisible4] = useIntersectionObserver({ threshold: 0.1 });
  const [sectionRef5, isVisible5] = useIntersectionObserver({ threshold: 0.1 });
  return (
    <div className="home-job-listing">
      <div className="home-job-overlay"></div>
      <div className="home-job-inner">
        <div className="home-whatwe-mainhead mb-3 text-center">
          Explore Our Latest Job Listings
        </div>
        <p className="main-para text-center">
          Discover a wide range of opportunities tailored to your skills and
          aspirations.
        </p>
        <div className="outer-container">
          <div className="home-sub-listing">
            {jobList.length>0 && jobList.map((job)=>(
            <div
              className={`home-inner-sub-listing ${
                isVisible1 ? "animate__fadeInUp" : ""
              }`}
              style={{ animationDuration: "1.25s" }}
              ref={sectionRef1}
            >
              <div className="home-verify-div">
                <span className="home-verify-box">
                  <PiSealCheckFill />
                  Verified Company
                </span>
              </div>
              <div className="home-body-outer">
                <div className="home-job-body">
                  <div className="home-job-head">{job.summary}</div>
                  <p className="home-job-para">{job.location}</p>
                </div>
                <div className="home-job-content-body">
                  <div className="choose-head">{job.skills}</div>
                  <p className="main-para">
                    {job.description}
                  </p>
                </div>
                <div className="home-job-footer">
                  <div className="home-job-footer-left">
                    <div className="home-job-description">
                      <span className="home-job-svg">
                        <FiBriefcase />
                      </span>
                      <span className="home-job-content">{job.job_type}</span>
                    </div>
                    <div className="home-job-description">
                      <span className="home-job-svg">
                        <FaBriefcase  />
                      </span>
                      <span className="home-job-content">{job.experiance}</span>
                    </div>
                  </div>
                  {/* <div className="home-job-footer-left">
                    <span className="home-page-btn1 mx-auto">View Detail</span>
                  </div> */}
                </div>
              </div>
            </div>))}
          </div>
        </div>
      </div>
    </div>
  );
}
